import { render, staticRenderFns } from "./PhotoDetail.vue?vue&type=template&id=34fddc83&scoped=true"
import script from "./PhotoDetail.vue?vue&type=script&lang=js"
export * from "./PhotoDetail.vue?vue&type=script&lang=js"
import style0 from "./PhotoDetail.vue?vue&type=style&index=0&id=34fddc83&prod&lang=scss"
import style1 from "./PhotoDetail.vue?vue&type=style&index=1&id=34fddc83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fddc83",
  null
  
)

export default component.exports